import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { StaticImage } from "gatsby-plugin-image";

// Import layout
import Layout from "../layouts/main";

// Import components
import Hero from "../components/hero";
import SEO from "../components/seo";
import Team from "../components/team";

// Import styles
import "./styles/about.scss";

// Import bootstrap
import { Container, Row } from "react-bootstrap";

const AboutPage = () => {
  const data = useStaticQuery(graphql`
    {
      allWpTeamMember(sort: { fields: date, order: DESC }) {
        nodes {
          excerpt
          featuredImage {
            node {
              id
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: TRACED_SVG, formats: AUTO)
                }
              }
            }
          }
          id
          title
          teamFields {
            email
            title
          }
          uri
        }
      }
      wpPage(title: { eq: "About" }) {
        aboutFields {
          aboutIntro {
            description
            fieldGroupName
            title
          }
          story {
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: TRACED_SVG, formats: AUTO)
                }
              }
            }
            text
          }
        }
        featuredImage {
          node {
            sourceUrl
          }
        }
        seoFields {
          seo {
            description
            title
          }
        }
        title
      }
    }
  `);

  const { allWpTeamMember, wpPage } = data;
  return (
    <Layout>
      <SEO
        title={wpPage.seoFields.seo.title}
        description={wpPage.seoFields.seo.description}
        image={wpPage.featuredImage.node.sourceUrl}
      />
      <div className="about">
        <Hero
          customClass="about"
          format="image-left"
          title={wpPage.aboutFields.aboutIntro.title}
          description={wpPage.aboutFields.aboutIntro.description}
          buttonLink=""
          buttonText=""
          image={
            <StaticImage
              placeholder="TRACED_SVG"
              src="../assets/images/about-badge.png"
              alt="A badge represent who Mtn Craft is."
            />
          }
        />
        <div className="story">
          <Container>
            <Row>
              <div className="headline">
                <h2 className="shout">Our Story:</h2>
              </div>
            </Row>
          </Container>
          <div className="story-container fade-in-slow">
            <GatsbyImage
              className="story-image"
              image={
                wpPage.aboutFields.story.image.localFile.childImageSharp
                  .gatsbyImageData
              }
              alt="test"
            />
            <Container>
              <p className="talk">{wpPage.aboutFields.story.text}</p>
            </Container>
          </div>
        </div>
        <Team data={allWpTeamMember} />
      </div>
    </Layout>
  );
};

export default AboutPage;
